module.exports = __webpack_public_path__ + "media/images/retired_benefits_inactive-597272c8.svg";